import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import "./events.css";

const Event = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null); // To store the event being edited
  const [newTitle, setNewTitle] = useState("");
  const [newDate, setNewDate] = useState("");
  const [newImage, setNewImage] = useState(null);

  // Fetch events on component mount
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch("https://api.deepticentre.com/deeptischool/list/events", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        });

        const data = await response.json();
        if (data.result && data.list) {
          setEvents(data.list);
        } else {
          console.error("No events found.");
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();
  }, []);

  // Edit event function to update event details
  const editEvent = async () => {
    if (!selectedEvent) return;

    try {
      const formData = new FormData();
      formData.append("e_id", selectedEvent.e_id);
      formData.append("e_title", newTitle || selectedEvent.e_title);
      formData.append("e_date", newDate || selectedEvent.e_date);
      if (newImage) formData.append("image", newImage);

      const response = await fetch("https://api.deepticentre.com/deeptischool/edit/events", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.success) {
        // Update the events list with the modified event
        setEvents(events.map(event => event.e_id === selectedEvent.e_id ? { ...event, e_title: newTitle, e_date: newDate, e_image: newImage ? newImage.name : event.e_image } : event));
        alert("Event updated successfully!");
      } else {
        console.error("Error updating event:", data);
      }
    } catch (error) {
      console.error("Error updating event:", error);
    }
  };

  return (
    <Container className="event-gallery-container">
      <div className="event-header">
        <h2>Our School Events</h2>
        <p className="school-events-description">
         We celebrate events that promote inclusion, awareness, and empowerment for students with diverse learning needs.
        </p>
      </div>

      {/* Event Cards Display */}
      <Row>
        {events.map((event, index) => (
          <Col key={event.e_id} md={4} sm={6} xs={12} className="mb-4">
            <motion.div
              initial={{ x: index % 2 === 0 ? -100 : 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1, ease: "easeOut" }}
            >
              <Card className="event-card shadow-sm" onClick={() => setSelectedEvent(event)}>
                <div className="event-img-wrapper">
                  <Card.Img
                    className="event-img"
                    src={`https://api.deepticentre.com${event.e_image}`}
                    alt={event.e_title}
                  />
                  <span className="event-date">{event.e_date}</span>
                </div>
                <Card.Body>
                  <Card.Title className="event-title">{event.e_title}</Card.Title>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>

      {/* Edit Event Form */}
      {selectedEvent && (
        <div className="edit-event-form">
          <h3>Edit Event</h3>
          <input
            type="text"
            value={newTitle || selectedEvent.e_title}
            onChange={(e) => setNewTitle(e.target.value)}
            placeholder="Enter new title"
          />
          <input
            type="text"
            value={newDate || selectedEvent.e_date}
            onChange={(e) => setNewDate(e.target.value)}
            placeholder="Enter new date"
          />
          <input
            type="file"
            onChange={(e) => setNewImage(e.target.files[0])}
          />
          <Button onClick={editEvent}>Update Event</Button>
        </div>
      )}
    </Container>
  );
};

export default Event;
